/* eslint-disable react/prop-types */
import React from 'react'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import Collapse from '@material-ui/core/Collapse'
import Link from '@material-ui/core/Link'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import MenuIcon from '@material-ui/icons/ArrowBackIos'
import LinkIcon from '@material-ui/icons/LinkOutlined'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import ImportantIcon from '@material-ui/icons/LabelOutlined'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import DoneAllIcon from '@material-ui/icons/DoneAll'

import { letterAvatars } from '../../Commons/utils'

const useStyle = makeStyles(theme => ({
  avatar: {
    color: '#FFF',
    backgroundColor: '#03B0EE',
  },
  toolbar: {
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
  },
  containerUserInfo: {
    paddingLeft: theme.spacing(1),
  },
  menuIcon: {
    display: 'contents',
    justifySelf: 'right',
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  listLinks: {
    transition: theme.transitions.create('height', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}))

export const InnerDrawer = props => {
  const {
    history,
    openDrawer,
    handleDrawer,
    profile,
    handleLinks,
    linksOpen,
    routes,
    showLinks,
    logout,
    showLinksAndMetrics,
    showMyAdvance,
    metricsOpen,
    handleMetrics,
    metricNumberSelected,
    handleMetricNumberSelected,
  } = props

  const classes = useStyle()

  return (
    <div style={{ height: '100%' }}>
      <div className={classes.toolbar}>
        <ListItem
          className={classes.containerUserInfo}
        >
          <ListItemIcon>
            <Avatar
              alt='Avatar'
              className={classes.avatar}
              onClick={() => handleDrawer(true)}
            >
              {letterAvatars(profile.name)}
            </Avatar>
          </ListItemIcon>
          <ListItemText
            style={{ margin: 0 }}
            primary={profile.name || ''}
            secondary={profile.email || ''}
          />
          <ListItem
            onClick={() => {
              handleDrawer(false)
              handleLinks(false)
              handleMetrics(false)
            }}
            button
            className={classes.menuIcon}
          >
            <MenuIcon color='action' />
          </ListItem>
        </ListItem>
      </div>
      <Divider />
      <List>
        {routes.map((route, i) => (
          <ListItem
            selected={history.location.pathname === route.route}
            onClick={() => history.push(route.route)}
            button
            key={i.toString()}
          >
            <ListItemIcon>{route.icon}</ListItemIcon>
            <ListItemText
              primary={route.title}
            />
          </ListItem>
        ))}
        {showMyAdvance && (
          <>
            <ListItem
              selected={history.location.pathname === '/dashboard/metrics'
                && (!openDrawer || !metricsOpen)}
              onClick={() => {
                handleMetrics(!metricsOpen)
                !openDrawer && handleDrawer(true)
              }}
              button
              key='Métricas'
            >
              <ListItemIcon><TrendingUpIcon /></ListItemIcon>
              <ListItemText
                primary='Métricas'
              />
              {metricsOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={metricsOpen} timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                {showLinksAndMetrics.showMetricsData.map((data, i) => (
                  <ListItem
                    selected={
                      history.location.pathname === '/dashboard/metrics'
                      && metricNumberSelected === i
                    }
                    onClick={() => {
                      history.push('/dashboard/metrics', { data })
                      handleMetricNumberSelected(i)
                    }}
                    button
                    key={i.toString()}
                    className={classes.nested}
                  >
                    <ListItemIcon>
                      <DoneAllIcon />
                    </ListItemIcon>
                    <ListItemText primary={data.title} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </>
        )}
        {showLinks && showLinksAndMetrics.showLinksData.map((data, i) => (
          <React.Fragment key={i.toString()}>
            <ListItem
              onClick={() => {
                handleLinks(!linksOpen)
                !openDrawer && handleDrawer(true)
              }}
              button
            >
              <ListItemIcon><ImportantIcon /></ListItemIcon>
              <ListItemText
                primary={data.title}
              />
              {linksOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={linksOpen} timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                {data.links.map((link, il) => (
                  <Link
                    key={il.toString()}
                    href={link.value}
                    target='_blank'
                    rel='noreferrer'
                    variant='inherit'
                    color='textSecondary'
                    underline='none'
                  >
                    <ListItem
                      button
                      className={classes.nested}
                    >
                      <ListItemIcon>
                        <LinkIcon />
                      </ListItemIcon>
                      <ListItemText primary={link.label} />
                    </ListItem>
                  </Link>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem
          onClick={logout}
          button
          key='Cerrar Sesión'
        >
          <ListItemIcon><ExitToAppIcon /></ListItemIcon>
          <ListItemText primary='Cerrar Sesión' />
        </ListItem>
      </List>
    </div>
  )
}

export default compose(withRouter)(InnerDrawer)
